import { PolicyFlowApproval } from 'src/types'

export const initialValues = {} as PolicyFlowApproval

export const defaultValue = {
  active: true,
  automatic_approval: false,
  code: '',
  consensual_approval: false,
  cost_center_approval: false,
  description: '',
  exception_approver: false,
  name: '',
  policy_approval_id: 'new',
  reason_approval: false
} as PolicyFlowApproval
